import {useAuthStore} from '@/features/auth/store/store'
import {useTranslation} from '@/translations/i18n'
import {StyledAgendaToolbarTitle} from './style'

export const AgendaToolbarMyAgendaTitle = () => {
    const {t} = useTranslation()
    const auth = useAuthStore(state => state.user)

    return (
        <StyledAgendaToolbarTitle align="center" justify="center">
            {auth?.fullName || t('agenda:my_agenda')}
        </StyledAgendaToolbarTitle>
    )
}
